<template>
    <v-dialog v-model="show" fullscreen transition="slide-y-transition" overlay-color="#111" overlay-opacity="0.95"
        :style="`${isAndroidNative ? 'margin-top: 100px; height: 100vh;' : ''} `">
        <v-card class="bg-dark pa-4 chatbot-dialog">
            <v-btn variant="tonal" class="mt-6" @click="close"
                style="position: absolute; top: 12px; right: 12px; z-index: 10; transition: 0.3s ease;color: #fff;">

                {{ $t('closeButton') }}
            </v-btn>

            <div class="content-scroll">
                <h2 class="text-white mb-6 text-center font-weight-bold">
                    {{ $t('assistant.title') }}
                </h2>

                <!-- Feature Cards -->
                <v-row class="mb-6" justify="center" no-gutters>
                    <v-col cols="12" sm="6" md="4" v-for="(card, i) in $tm('assistant.cards')" :key="i" class="pa-2">
                        <v-card class="chatbot-card">
                            <v-icon :color="card.color" size="32">{{ card.icon }}</v-icon>
                            <div class="text-white font-weight-bold mt-2">
                                {{ card.title }}
                            </div>
                            <ul class="text-white mt-2 bullet-list">
                                <li v-for="(point, j) in card.points" :key="j">{{ point }}</li>
                            </ul>
                        </v-card>
                    </v-col>
                </v-row>

                <!-- Visual Preview -->
                <v-card class="chat-preview">
                    <v-icon size="30" color="cyan">mdi-microphone</v-icon>
                    <p class="text-white font-weight-medium mt-2">"{{ $t('assistant.samples[0]') }}"</p>
                    <p class="text-white font-weight-medium">"{{ $t('assistant.samples[1]') }}"</p>
                    <p class="text-white font-weight-medium">"{{ $t('assistant.samples[2]') }}"</p>
                </v-card>

                <!-- Chips -->
                <div class="chip-group mt-6">
                    <v-chip color="cyan" class="ma-1" label>{{ $t('assistant.commands[0]') }}</v-chip>
                    <v-chip color="indigo" class="ma-1" label>{{ $t('assistant.commands[1]') }}</v-chip>
                    <v-chip color="green" class="ma-1" label>{{ $t('assistant.commands[2]') }}</v-chip>
                    <v-chip color="amber" class="ma-1" label>{{ $t('assistant.commands[3]') }}</v-chip>
                    <v-chip color="purple" class="ma-1" label>{{ $t('assistant.commands[4]') }}</v-chip>
                </div>
            </div>
        </v-card>
    </v-dialog>
</template>


<script setup>
import { ref, defineExpose } from 'vue';
import { Capacitor } from '@capacitor/core';
const isAndroidNative = Capacitor.getPlatform() === 'android' && Capacitor.isNativePlatform();

const show = ref(false);
function open() { show.value = true; }
function close() { show.value = false; }
defineExpose({ open });

const cards = [
    {
        title: '🎤 Speech & Text Interaction',
        icon: 'mdi-microphone-message',
        color: 'cyan',
        points: [
            'Speech-to-text with Gemini',
            'Natural language UI',
            'Multilingual auto-detection'
        ]
    },
    {
        title: '📅 Smart Booking Assistant',
        icon: 'mdi-calendar-check',
        color: 'green lighten-1',
        points: [
            'Book desks or rooms by voice',
            'Suggest optimal time slots',
            'Live occupancy queries'
        ]
    },
    {
        title: '🚨 Issue Reporting',
        icon: 'mdi-alert-circle-check-outline',
        color: 'red lighten-1',
        points: [
            'Auto-create tickets',
            'Suggest correct category',
            'Route to right department'
        ]
    },
    {
        title: '🌐 Integrated Commands',
        icon: 'mdi-console-line',
        color: 'purple lighten-2',
        points: [
            'Open dashboards',
            'Navigate across app',
            'Trigger custom API actions'
        ]
    }
];
</script>

<style scoped>
.bg-dark {
    background-color: #111;
    min-height: 100vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.chatbot-dialog {
    width: 100%;
    max-width: 100vw;
    margin: 0 auto;
}

.close-btn {
    position: fixed;
    top: 12px;
    right: 12px;
    z-index: 100;
    background-color: #000000cc;
}

.content-scroll {
    width: 100%;
    max-width: 1100px;
    padding: 16px;
    padding-top: 64px;
    box-sizing: border-box;
}

.chatbot-card {
    background-color: #1e1e1e;
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 255, 255, 0.06);
    text-align: center;
    transition: transform 0.3s ease;
}

.chatbot-card:hover {
    transform: scale(1.03);
    box-shadow: 0 8px 20px rgba(0, 255, 255, 0.12);
}

.bullet-list {
    text-align: left;
    font-size: 0.9rem;
    margin-top: 8px;
    padding-left: 16px;
    list-style: disc;
}

.chat-preview {
    background: #1a1a1a;
    padding: 24px;
    border-radius: 16px;
    text-align: center;
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.07);
}

.chip-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
}
</style>